import React from "react";
import sliderInner from '../assets/images/take-pledge-banner.jpg';

function Pledge() {

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  scrollToTop()

  return (
    <>
      <section className="sliderSec sliderInnerSec">
        <img src={sliderInner} alt="" />
        <div className="sliderInrHdng">
          <h2>Take  <span className="hdngBrkr">A Pledge</span></h2>
        </div>
      </section>
      <section className="sevenScopeSec reduceWasteSec aboutUsSec">
        <div className="container-fluid">
          <span className="contact__shape-1"></span>
          <h2>About <span className="hdngBrkr">Eco-Clubs</span> </h2>
          <div className="sevenScopeBox">
            <p>The NEP 2020, emphasizes integration of environmental awareness and sustainability into school curricula. It recognizes the imperative to instill environmental consciousness from an early age, integrating dedicated chapters on the environment into the National Curriculum Framework.</p>
            <p>Department of School Education & Literacy through Samagra Shiksha Scheme, have established eco club in government schools nationwide, fostering a deep-rooted connection to nature among students and the wider community. </p>
            <p>The National Curriculum Framework aligned with NEP 2020 also focuses on adoption and practice of eco-friendly activities in schools. Eco clubs can play a pivotal role in promoting Mission LiFE (Lifestyle for Environment) goals and mobilize individuals to become “Pro-Planet People” and schools are the best place to imbibe these skills.</p>
            <p>The salient seven core thematic areas of Mission LiFE would be mapped into defined activities and associated with an equivalent metric for measurement.</p>
          </div>
        </div>
      </section>
    </>
  );
}

export default Pledge;
